import { createTrackedNumberUpdate } from "#/admin/legacy/page-builder/tracked-number-update.js";
import {
  listenForTrackedNumberPicks,
  updateTrackedNumberForm,
} from "#/admin/legacy/page-builder/tracked-number-select.js";

(function () {
  "use strict";

  var CallTrackingManager = {
    numbers: {},
    workflow_items: [],
    initialized: false,

    initialize: function (data) {
      this.numbers = data.numbers;
      this.workflow_items = data.workflow_items;
      this.initialized = true;
      triggerEvent("initialize", this.getFieldsets());
    },

    find: function (number) {
      return this.numbers[number] || { original_number: number };
    },

    updateForm: function (number) {
      var numberData = this.find(number);

      return updateTrackedNumberForm(numberData, this.addFieldset.bind(this));
    },

    addFieldset: function (numberData) {
      var newFieldset = jQuery("#tracked_number_blueprint").html();
      newFieldset = newFieldset.replace(/CHILD_INDEX/g, numberData.fieldset_id);
      newFieldset = newFieldset.replace(/ORIGINAL_NUMBER_ID/g, numberData.original_number_id);
      newFieldset = newFieldset.replace(/ORIGINAL_NUMBER_STRING/g, numberData.original_number);
      newFieldset = newFieldset.replace(/FIELDSET_ID/g, numberData.fieldset_id);

      newFieldset = jQuery(newFieldset);

      if (!numberData.wants_local_number) {
        newFieldset.find("[data-show-if=wants-local-number]").remove();
      }

      jQuery("#tracked-numbers-fields-container").prepend(newFieldset);

      Form.decorate(newFieldset);

      return newFieldset;
    },

    getFieldsets: function () {
      return jQuery(".tracked-number-fieldset");
    },
  };

  CallTrackingManager.update = createTrackedNumberUpdate(CallTrackingManager, triggerEvent);

  jQuery(document).on("change", ".tracked-number-enabled-input", function (e) {
    var $input = jQuery(e.target);
    CallTrackingManager.update($input.data("original-number"), { enabled: $input.prop("checked") });
  });

  jQuery(document).on("change", ".tracked-number-workflow-input", function (e) {
    var $select = jQuery(e.target);

    CallTrackingManager.update($select.data("original-number"), { workflow_id: $select.val() });
  });

  function addPickedNumber(item) {
    CallTrackingManager.update(item.title, { original_number_id: item.value, enabled: true });
  }

  listenForTrackedNumberPicks(addPickedNumber);

  // HELPER FUNCTIONS

  function triggerEvent(name, payload) {
    jQuery(CallTrackingManager).triggerHandler(name, [payload]);
  }

  // export
  _.extend(Sparkle.PageBuilder, { CallTrackingManager: CallTrackingManager });
})();
